export default __webpack_public_path__ + "./images/uk.1e574697.png";